import React from "react";
import { styles } from "./CarSubmission.styles";
import { ContentAfterRecordCheck, IContentAfterRecordCheckProps } from "./components/ContentAfterRecordCheck";
import { CarDetails, ICarDetailsProps } from "./components/CarDetails";
import { ILpPrediction } from "./components/CarDetails/LicensePlateDetection/CarDetailsLpDetection";
import { SectionBadge } from "../SectionBadge";
import { SectionBadgeVariants } from "../SectionBadge/SectionBadge.style";

export type { ILpPrediction };

export interface IZoomDataLayerEvents {
  aiZoomTriggeredEvent: () => void;
  aiZoomNotTriggeredEvent: () => void;
}
export interface ICarSubmissionProps extends ICarDetailsProps, IContentAfterRecordCheckProps {
  title: string;
  partnerLogo?: string;
  showContent: boolean;
  isZoomEnabled?: boolean;
  isLicensePlateDetection?: boolean;
  children?: React.ReactNode;
  zoomDataLayerEvents: IZoomDataLayerEvents;
  fetchLpPrediction: (carImageUrl: string) => Promise<ILpPrediction>;
}

export function CarSubmission({
  title,
  partnerLogo,
  carImage,
  subtitle,
  afterVinCheck,
  vhrFound,
  onCtaClick,
  ctaLink,
  ctaText,
  VinSearchComponent,
  showContent,
  isVinValid,
  isZoomEnabled = false,
  isLicensePlateDetection = false,
  zoomDataLayerEvents,
  fetchLpPrediction,
  translations,
  ctaRef,
  secondaryCta,
  children,
}: ICarSubmissionProps) {
  return (
    <div className={styles.root(!!carImage)}>
      {partnerLogo && translations.partnerBadgeText && !carImage && (
        <div className={styles.partnerLogo()}>
          <SectionBadge
            text={translations.partnerBadgeText}
            variant={SectionBadgeVariants.Partner}
            imageUrl={partnerLogo}
            imageAltText={translations.partnerBadgeImageAlt}
          />
        </div>
      )}
      {showContent && (
        <>
          <h1 className={styles.title()}>{title}</h1>
          <ContentAfterRecordCheck
            subtitle={subtitle}
            afterVinCheck={afterVinCheck}
            vhrFound={vhrFound}
            isVinValid={isVinValid}
            onCtaClick={onCtaClick}
            ctaLink={ctaLink}
            ctaText={ctaText}
            VinSearchComponent={VinSearchComponent}
            ctaRef={ctaRef}
            secondaryCta={secondaryCta}
          />
        </>
      )}
      {children && <div className={styles.loader()}>{children}</div>}
      {carImage && (
        <CarDetails
          partnerLogo={partnerLogo}
          carImage={carImage}
          isZoomEnabled={isZoomEnabled}
          isLicensePlateDetection={isLicensePlateDetection && isZoomEnabled && !isVinValid && showContent}
          zoomDataLayerEvents={zoomDataLayerEvents}
          fetchLpPrediction={fetchLpPrediction}
          translations={translations}
        />
      )}
    </div>
  );
}
